import { createSlice } from '@reduxjs/toolkit';

export const updateZatcaModalSlice = createSlice({
    name: 'updateZatcaModal',
    initialState: {
        showModal: false
    },
    reducers: {
        setUpdateZatcaModal: (state, action) => {
            state.showModal = action.payload;
        },
    },
});

export const { setUpdateZatcaModal } = updateZatcaModalSlice.actions;
export default updateZatcaModalSlice.reducer;
